import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import Error from 'next/error';
import { stores } from '@studionand/ada-next/src/stores';
import withStores from '@studionand/ada-next/src/stores/withStores';
import { getRouteConfig } from '../namedRoutes';
import useStores from '../utils/useStores';
import withAuth from '../utils/withAuth';
import { CONTEXT_PAGE_LABELS } from '../config';
import PageMeta from '@studionand/ada-next/src/components/PageMeta';
import getExternalUrl from '../utils/getExternalUrl';

const getInitialProps = config => async ({
  query,
  adaStores: { appStore },
}) => {
  appStore.setPageIsEditable(true);
  const slug = query.pageId;
  const namedRoute = getRouteConfig(config, slug);
  const uuid = namedRoute && namedRoute.uuid;
  let res = { status: 404 };
  if (namedRoute) res = await stores.pagesStore.instance.loadPage(uuid, true);
  stores.appStore.instance.setEditMode(false);
  return {
    slug,
    errorCode: res.status > 200 ? res.status : null,
    internal: namedRoute && namedRoute.internal,
  };
};

const NamedPageContent = props => {
  const {
    slug,
    config,
    pagesStore,
    errorCode,
    layoutComponent: Layout,
    editorComponent: Editor,
  } = props;
  const { uiStore } = useStores();
  const namedRoute = getRouteConfig(config, slug) || {};
  const externalUrl = getExternalUrl(uiStore.context);
  return (
    <Layout {...namedRoute.layoutProps}>
      {!errorCode && (
        <React.Fragment>
          <PageMeta
            page={pagesStore.getPage(namedRoute.uuid)}
            titlePrefix={`${CONTEXT_PAGE_LABELS[uiStore.context]} - `}
            assetPath={`${externalUrl}/ada-assets`}
          />
          <Editor page={pagesStore.getPage(namedRoute.uuid)} />
          {namedRoute.children}
        </React.Fragment>
      )}
      {errorCode && <Error statusCode={errorCode} />}
    </Layout>
  );
};
NamedPageContent.displayName = 'NamedPageContent';
NamedPageContent.getInitialProps = getInitialProps;

const NamedPage = props => {
  const { internal } = props;
  if (internal) {
    const NamedPageContentWithAuth = withAuth(NamedPageContent);
    return <NamedPageContentWithAuth {...props} />;
  } else {
    return <NamedPageContent {...props} />;
  }
};

NamedPage.getInitialProps = getInitialProps;

NamedPage.propTypes = {
  config: PropTypes.array.isRequired,
  layoutComponent: PropTypes.node.isRequired,
  editorComponent: PropTypes.node.isRequired,
};

export default withStores('pagesStore')(observer(NamedPage));
